// extracted by mini-css-extract-plugin
module.exports = {"dataChart":"AllCharts_dataChart__2hqKm","chartInnerCard":"AllCharts_chartInnerCard__3qVUH"};